const NEED_ALIASES = {
  revenue: ['revenue', 'arr', 'monthly_revenue', 'annual_revenue', 'sales'],
  hours_per_week: ['hours_per_week', 'time_spent', 'hoursPerWeek', 'working_hours'],
  team_size: ['team_size', 'teamSize', 'employees', 'staff'],
  business_stage: ['business_stage', 'growth_stage', 'stage'],
  avg_ticket: ['avg_ticket', 'average_ticket', 'avgSale', 'average_sale', 'average_order_value', 'aov'],
  gross_margin: ['gross_margin', 'margin', 'profit_margin']
};

const NEED_KEYS = Object.keys(NEED_ALIASES);

const NORMALIZE_NUMBER = /[\$,]/g;

const toNumber = (value) => {
  if (value == null) return null;
  if (typeof value === 'number') return value;
  const str = String(value).trim();
  if (!str) return null;
  const cleaned = str.replace(NORMALIZE_NUMBER, '').toLowerCase();
  let multiplier = 1;
  if (cleaned.endsWith('k')) multiplier = 1_000;
  if (cleaned.endsWith('m')) multiplier = 1_000_000;
  const numeric = parseFloat(cleaned.replace(/[kmb]/g, ''));
  if (Number.isFinite(numeric)) {
    return numeric * multiplier;
  }
  return null;
};

const extractFirstValue = (entry) => {
  if (!entry) return null;
  if (Array.isArray(entry)) {
    return entry.length > 0 ? entry[0] : null;
  }
  return entry;
};

export const buildDerivedContextMap = (context = {}) => {
  const map = {};
  
  // First, map known/generic fields with aliases
  NEED_KEYS.forEach((target) => {
    const aliases = NEED_ALIASES[target];
    for (const alias of aliases) {
      const value = extractFirstValue(context?.[alias]);
      if (value !== undefined && value !== null && value !== '') {
        const parsedNumber = toNumber(value);
        map[target] = parsedNumber ?? value;
        break;
      }
    }
  });
  
  // CRITICAL FIX: Also include ALL other context keys (framework-specific fields)
  // This allows framework tools to work with custom field names
  Object.keys(context || {}).forEach((key) => {
    if (!map[key]) {  // Don't override if already mapped via alias
      const value = extractFirstValue(context[key]);
      if (value !== undefined && value !== null && value !== '') {
        map[key] = value;
      }
    }
  });
  
  return map;
};

export const getDerivedContextKeys = (context = {}) => {
  const map = buildDerivedContextMap(context);
  return Object.keys(map).filter((key) => map[key] !== undefined && map[key] !== null && map[key] !== '');
};

export const hashContextKeys = (keys = []) => {
  if (!Array.isArray(keys) || keys.length === 0) return '';
  return keys.slice().sort().join('|');
};

export { NEED_KEYS };

